import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { MaintenanceTypeService } from '../../core/services/maintenance-type.service';
import { ViewTypeService } from '../../core/services/view-type.service';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ViewType } from '../../core/models/view-type.model';
import { MaintenanceTypeFormBaseComponent } from '../maintenance-type-form-base.component';

@Component({
  selector: 'app-maintenance-type-update',
  templateUrl: './maintenance-type-update.component.html',
  styleUrls: ['./maintenance-type-update.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, HttpClientModule, CommonModule],
})
export class MaintenanceTypeUpdateComponent
  extends MaintenanceTypeFormBaseComponent
  implements OnInit
{
  override viewTypes: ViewType[] = [];
  maintenanceTypeId: number | null = null;

  constructor(
    protected override fb: FormBuilder,
    private route: ActivatedRoute,
    private maintenanceTypeService: MaintenanceTypeService,
    private viewTypeService: ViewTypeService,
    private router: Router,
  ) {
    super(fb);
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id !== null) {
      this.maintenanceTypeId = +id;
      this.loadMaintenanceType();
    }
    this.loadViewTypes();
  }

  loadMaintenanceType(): void {
    if (this.maintenanceTypeId !== null) {
      this.maintenanceTypeService.getMaintenanceType(this.maintenanceTypeId).subscribe({
        next: maintenanceType => {
          this.maintenanceTypeForm.patchValue(maintenanceType);
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error al cargar el tipo de mantenimiento:', error.message);
          this.errorMessage =
            error.error.message || 'Ocurrió un error al cargar el tipo de mantenimiento';
        },
      });
    }
  }

  loadViewTypes(): void {
    this.viewTypeService.getViewTypes().subscribe({
      next: viewTypes => {
        this.viewTypes = viewTypes;
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error al cargar los tipos de vista:', error.message);
        this.errorMessage = error.error.message || 'Ocurrió un error al cargar los tipos de vista';
      },
    });
  }

  onSubmit(): void {
    if (this.maintenanceTypeForm.valid && this.maintenanceTypeId !== null) {
      this.maintenanceTypeService
        .updateMaintenanceType(this.maintenanceTypeId, this.maintenanceTypeForm.value)
        .subscribe({
          next: response => {
            console.log('Tipo de Mantenimiento actualizado:', response);
            this.router.navigate(['/maintenance-types']);
          },
          error: (error: HttpErrorResponse) => {
            console.error('Error al actualizar el tipo de mantenimiento:', error.message);
            this.errorMessage =
              error.error.message || 'Ocurrió un error al actualizar el tipo de mantenimiento';
          },
          complete: () => {
            console.log('Solicitud de actualización de tipo de mantenimiento completada');
          },
        });
    } else {
      this.markAllFieldsAsTouched();
      this.errorMessage = 'Por favor, complete todos los campos obligatorios.';
    }
  }
}
